export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

export function unauthorized(message = "Authentication required") {
  return new ApiError(401, message);
}

export function forbidden(message = "You do not have access to this resource") {
  return new ApiError(403, message);
}

export function notFound(message = "Not found") {
  return new ApiError(404, message);
}

export function conflict(message = "Conflict") {
  return new ApiError(409, message);
}

export function badRequest(message = "Invalid request") {
  return new ApiError(400, message);
}
